export const LANTERNS = [
  { left: 15.9, top: 78.2 },
  { left: 83.5, top: 78.2 },
];

export const GLOWS = [
  { variant: "f2", left: 11.49, top: 13.5, d: 2.0, dl: 1.2 },
  { variant: "", left: 83.03, top: 50.91, d: 2.0, dl: 0.3 },
  { variant: "f2", left: 84.76, top: 67.92, d: 3.0, dl: 0.4 },
  { variant: "", left: 14.83, top: 44.11, d: 2.9, dl: 0.4 },
  { variant: "", left: 92.13, top: 22.93, d: 2.5, dl: 1.2 },
  { variant: "", left: 86.65, top: 11.31, d: 1.9, dl: 0.1 },
  { variant: "", left: 13.64, top: 55.03, d: 2.4, dl: 0.6 },
  { variant: "f2", left: 19.21, top: 9.47, d: 2.4, dl: 2.9 },
  { variant: "f2", left: 82.21, top: 11.91, d: 2.1, dl: 1.8 },
  { variant: "", left: 71.15, top: 9.21, d: 3.3, dl: 2.5 },
  { variant: "f2", left: 82.78, top: 9.95, d: 2.1, dl: 2.5 },
  { variant: "", left: 78.49, top: 17.36, d: 1.8, dl: 2.2 },
  { variant: "", left: 3.8, top: 4.07, d: 2.8, dl: 0.7 },
  { variant: "", left: 16.61, top: 59.83, d: 3.0, dl: 0.6 },
  { variant: "", left: 15.69, top: 50.68, d: 2.2, dl: 0.1 },
  { variant: "f2", left: 85.72, top: 47.49, d: 2.3, dl: 1.2 },
  { variant: "", left: 90.23, top: 9.03, d: 3.1, dl: 2.9 },
  { variant: "", left: 20.31, top: 3.96, d: 3.4, dl: 2.4 },
  { variant: "f2", left: 28.83, top: 6.4, d: 2.1, dl: 1.9 },
  { variant: "", left: 88.91, top: 9.07, d: 2.9, dl: 0.3 },
];

export const PETALS = [
  { left: 25.8, top: 6.6, pw: 10.4, ph: 6.4, pd: 12.5, pdel: 1.5 },
  { left: 76.0, top: 10.1, pw: 12.7, ph: 7.9, pd: 8.8, pdel: 8.2 },
  { left: 16.5, top: 14.7, pw: 9.2, ph: 5.7, pd: 13.3, pdel: 2.2 },
  { left: 90.8, top: 9.4, pw: 14.0, ph: 8.7, pd: 9.0, pdel: 4.2 },
  { left: 3.7, top: 13.6, pw: 12.2, ph: 7.6, pd: 9.1, pdel: 2.5 },
  { left: 58.6, top: 4.6, pw: 12.4, ph: 7.7, pd: 10.4, pdel: 9.2 },
  { left: 3.4, top: 14.5, pw: 14.9, ph: 9.2, pd: 12.1, pdel: 9.7 },
  { left: 92.4, top: 3.0, pw: 11.8, ph: 7.3, pd: 8.4, pdel: 10.2 },
  { left: 17.7, top: 3.2, pw: 11.7, ph: 7.3, pd: 12.3, pdel: 7.2 },
  { left: 60.3, top: 16.0, pw: 9.3, ph: 5.8, pd: 12.6, pdel: 12.7 },
  { left: 24.3, top: 16.2, pw: 12.2, ph: 7.6, pd: 9.2, pdel: 6.1 },
  { left: 87.5, top: 13.4, pw: 11.3, ph: 7.0, pd: 13.2, pdel: 0.5 },
  { left: 16.4, top: 2.1, pw: 11.1, ph: 6.9, pd: 13.4, pdel: 1.5 },
  { left: 98.4, top: 15.5, pw: 13.1, ph: 8.1, pd: 8.3, pdel: 6.1 },
  { left: 22.5, top: 3.0, pw: 10.8, ph: 6.7, pd: 8.5, pdel: 11.0 },
  { left: 95.3, top: 15.8, pw: 13.5, ph: 8.4, pd: 11.2, pdel: 0.8 },
  { left: 15.9, top: 13.3, pw: 13.5, ph: 8.4, pd: 8.1, pdel: 0.1 },
  { left: 58.9, top: 15.8, pw: 9.7, ph: 6.0, pd: 10.1, pdel: 6.2 },
  { left: 28.4, top: 3.6, pw: 10.6, ph: 6.6, pd: 12.2, pdel: 1.1 },
  { left: 62.2, top: 1.9, pw: 14.7, ph: 9.1, pd: 9.3, pdel: 6.5 },
  { left: 12.8, top: 16.7, pw: 13.3, ph: 8.2, pd: 11.3, pdel: 6.4 },
  { left: 66.8, top: 14.5, pw: 9.6, ph: 6.0, pd: 11.4, pdel: 3.8 },
  { left: 9.6, top: 8.5, pw: 10.1, ph: 6.3, pd: 11.3, pdel: 0.9 },
  { left: 55.8, top: 3.7, pw: 9.5, ph: 5.9, pd: 12.8, pdel: 6.6 },
  { left: 22.0, top: 13.6, pw: 10.0, ph: 6.2, pd: 13.2, pdel: 5.0 },
  { left: 75.3, top: 9.1, pw: 13.2, ph: 8.2, pd: 12.2, pdel: 2.5 },
  { left: 26.7, top: 8.1, pw: 10.5, ph: 6.5, pd: 12.8, pdel: 11.3 },
  { left: 92.8, top: 6.5, pw: 14.5, ph: 9.0, pd: 12.3, pdel: 12.6 },
  { left: 24.4, top: 17.0, pw: 11.9, ph: 7.4, pd: 12.1, pdel: 10.2 },
  { left: 78.1, top: 9.3, pw: 11.4, ph: 7.1, pd: 12.8, pdel: 4.9 },
  { left: 24.1, top: 10.2, pw: 13.2, ph: 8.2, pd: 9.7, pdel: 1.0 },
  { left: 84.7, top: 3.7, pw: 11.2, ph: 6.9, pd: 12.3, pdel: 0.6 },
  { left: 29.2, top: 10.6, pw: 12.4, ph: 7.7, pd: 11.7, pdel: 0.7 },
  { left: 56.0, top: 12.7, pw: 12.5, ph: 7.8, pd: 11.5, pdel: 10.7 },
  { left: 9.4, top: 4.0, pw: 14.8, ph: 9.2, pd: 8.3, pdel: 6.7 },
  { left: 82.5, top: 16.3, pw: 9.5, ph: 5.9, pd: 11.9, pdel: 1.0 },
  { left: 15.1, top: 11.1, pw: 14.1, ph: 8.7, pd: 8.3, pdel: 9.7 },
  { left: 61.5, top: 7.8, pw: 14.9, ph: 9.2, pd: 12.7, pdel: 1.0 },
  { left: 1.1, top: 2.0, pw: 13.7, ph: 8.5, pd: 8.2, pdel: 10.2 },
  { left: 90.5, top: 14.2, pw: 14.6, ph: 9.1, pd: 11.5, pdel: 10.7 },
  { left: 17.8, top: 11.9, pw: 9.4, ph: 5.8, pd: 11.0, pdel: 12.9 },
  { left: 72.1, top: 12.6, pw: 10.1, ph: 6.3, pd: 10.6, pdel: 7.0 },
  { left: 24.9, top: 6.5, pw: 11.8, ph: 7.3, pd: 9.0, pdel: 7.5 },
  { left: 96.4, top: 7.5, pw: 13.0, ph: 8.1, pd: 11.1, pdel: 2.5 },
];
